import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TrafficUsageService {
  apiURL = environment.apiURL;
  constructor(private http: HttpClient) { }

  addTrafficUsage(data:any){
    return this.http.post(this.apiURL+'traffic-usages', data);
  }

}
